// This import loads the firebase namespace along with all its type information.
import MarketingMetric from './marketing-metric-model'

export async function load_marketingMetrics(): Promise<MarketingMetric[]> {
  throw 'Not implemented'
}

export async function delete_marketingMetric(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_marketingMetric(): Promise<MarketingMetric> {
  throw 'Not implemented'
}
